import React, { Component, Fragment } from "react";
import FlexText from "../../flexText";
import Styles from "./style/style";

class BoxText extends Component {
  render() {
    const nonVideoHeight = this.props.video === true ? 0 : this.props.height;
    if (window.innerWidth >= 900) {
      return (
        <div
          className="BoxTextOnly"
          style={{
            ...this.props.styles,
            ...Styles.containerStyles,
            backgroundColor: this.props.blockStyle.attributes.field_color_1
          }}
        >
          <FlexText
            max="16"
            min="16"
            pert=".25"
            classes="flexText"
            tag="div"
            color={
              this.props.blockStyle.attributes.field_text_color_font[0]
                .field_color_1
            }
            styles={{
              fontFamily: this.props.blockStyle.attributes
                .field_text_color_font[0].field_font_1.name
            }}
          >
            {this.props.children}
          </FlexText>
          <div
            style={{
              height: "42px",
              width: "42px",
              backgroundColor: "transparent",
              position: "absolute",
              right: "3px",
              bottom: "3px",
              borderRight: "8px solid rgb(255, 255, 255)",
              transform: "rotate(45deg)"
            }}
          />
        </div>
      );
    } else if (window.innerWidth > 600) {
      return (
        <Fragment>
          <div style={{ height: nonVideoHeight - 1 + "px" }} />
          <div
            className="BoxText"
            style={{
              ...this.props.styles,
              ...Styles.containerStyles,
              backgroundColor: this.props.blockStyle.attributes.field_color_1
            }}
          >
            {this.props.text !== null ? (
              <FlexText
                color={
                  this.props.blockStyle.attributes.field_text_color_font[0]
                    .field_color_1
                }
                tag="h2"
                max="24"
                min="18"
                styles={{
                  verticalAlign: "middle",
                  fontFamily: "Oswald",
                  textTransform: "uppercase",
                  padding: "0px",
                  margin: "0"
                }}
              >
                {this.props.text}
              </FlexText>
            ) : null}
            <FlexText
              max="20"
              min="16"
              pert=".25"
              classes="flexText"
              tag="div"
              color={
                this.props.blockStyle.attributes.field_text_color_font[0]
                  .field_color_1
              }
              styles={{
                fontFamily: this.props.blockStyle.attributes
                  .field_text_color_font[0].field_font_1.name
              }}
            >
              {this.props.children}
            </FlexText>
          </div>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <div style={{ height: nonVideoHeight - 1 + "px" }} />
          <div
            className="BoxText"
            style={{
              ...this.props.style,
              ...Styles.containerStyles,
              backgroundColor: this.props.blockStyle.attributes.field_color_1,
              position: "relative"
            }}
          >
            {this.props.text !== null ? (
              <FlexText
                color={
                  this.props.blockStyle.attributes.field_text_color_font[0]
                    .field_color_1
                }
                tag="h2"
                max="24"
                min="18"
                styles={{
                  verticalAlign: "middle",
                  fontFamily: "Oswald",
                  textTransform: "uppercase",
                  padding: "0px",
                  margin: "0"
                }}
              >
                {this.props.text}
              </FlexText>
            ) : null}
            <FlexText
              max="20"
              min="16"
              pert=".25"
              classes="flexText"
              tag="div"
              color={
                this.props.blockStyle.attributes.field_text_color_font[0]
                  .field_color_1
              }
              styles={{
                fontFamily: this.props.blockStyle.attributes
                  .field_text_color_font[0].field_font_1.name,
                marginTop: "8px"
              }}
            >
              {this.props.children}
            </FlexText>
          </div>
        </Fragment>
      );
    }
  }
}

export default BoxText;
